import {
    deviceManager,
    joinRequest,
    kinoLimits,
    vb,
    convertPath,
    electronConfig,
    privacyMode,
    onLocalTracks,
    connection,
    initSocketMessage,
    startRoom,
    socket,
    isElectron,
    isMac,
    isWindows,
    animatedLayers,
    permissions,
    isJoined,
    noVirtualBackgroundIcon
} from '../libs/roomnew';
import sanitizeHtml from 'sanitize-html';
import LoginModal from '../Auth/Modals/LoginModal';
import axios from 'axios';
import moment from 'moment';
import DevicesSettings from './devices/DevicesSettings';
import DeviceTestMeters from './devices/DeviceTestMeters';
import DeviceTroubleshootingGuide from './devices/DeviceTroubleshootingGuide';
import DeviceWizard from './devices/DevicesWizard';
import Session from './Session';
import { hasDeviceAccessToContinue } from '../features/session-limit/functions';
// import { signOut } from '../../renderer/libs/user';//un comment on electron

/**
 * Sort a flat array of {deviceId, ...} objects so the active device is first,
 * the last-used (if different) is second, and the rest keep their original order.
 */
function sortDevicesByRecency(devices, selectedId, lastUsedId) {
    return [...devices].sort((a, b) => {
        const rankA = a.deviceId === selectedId ? 0
            : (lastUsedId && lastUsedId !== selectedId && a.deviceId === lastUsedId) ? 1 : 2;
        const rankB = b.deviceId === selectedId ? 0
            : (lastUsedId && lastUsedId !== selectedId && b.deviceId === lastUsedId) ? 1 : 2;
        return rankA - rankB;
    });
}

export default class KinoLobby {
    constructor(){
        this.lobby;
        this.loginModal = new LoginModal();
        this.showJoinOverlay = null;
        this.timeout;
        this.automaticJoinTimeout;
        this._availabilityRequestId = 0;
        //icons
        this.kinoLogo = `<img src="/images/KinoLiveDarkBG.svg" alt="Kino Logo" class="kino-logo-img" />`;
        this.dropDownArrow = `<svg width="10" height="7" viewBox="0 0 10 7" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10 1.175L8.825 -5.13609e-08L5 3.81667L1.175 -3.85753e-07L-5.13609e-08 1.175L5 6.175L10 1.175Z" fill="white"/></svg>`;
        this.microphoneIcon = `<svg width="400" height="400" viewBox="0 0 400 400" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M200.391 265.625C236.714 265.625 266.273 236.181 266.273 200V90.625C266.273 54.4437 236.714 25 200.391 25C164.067 25 134.508 54.4437 134.508 90.625V200C134.508 236.181 164.067 265.625 200.391 265.625Z" fill="white"/>
        <path d="M299.215 178.125C293.154 178.125 288.234 183.025 288.234 189.062V200C288.234 248.256 248.836 287.5 200.391 287.5C151.945 287.5 112.547 248.256 112.547 200V189.062C112.547 183.025 107.628 178.125 101.566 178.125C95.5052 178.125 90.5859 183.025 90.5859 189.062V200C90.5859 256.569 134.069 302.681 189.41 308.259V364.062C189.41 370.1 194.329 375 200.391 375C206.452 375 211.371 370.1 211.371 364.062V308.259C266.713 302.681 310.195 256.569 310.195 200V189.062C310.195 183.025 305.276 178.125 299.215 178.125Z" fill="white"/>
        </svg>`;
        this.microphoneOffIcon = `<svg width="400" height="400" viewBox="0 0 400 400" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M265.403 88.2228C264.31 53.2236 235.217 25.0055 199.999 25.0055C163.906 25.0055 134.375 54.536 134.375 90.6289V200.001C134.375 205.907 135.25 211.376 136.781 216.845L265.403 88.2228Z" fill="#FF3D00"/>
        <path d="M199.999 265.625C236.092 265.625 265.622 236.094 265.622 200.001V149.843L371.801 43.6644C376.066 39.3989 376.066 32.4647 371.801 28.1991C367.535 23.9336 360.601 23.9336 356.336 28.1991L28.2183 356.316C23.9309 360.582 23.9309 367.516 28.1964 371.782C32.4619 376.069 39.3743 376.069 43.6617 371.804L131.335 284.131C147.565 297.19 167.253 306.049 189.061 308.28V364.06C189.061 370.185 193.874 374.997 199.999 374.997C206.123 374.997 210.936 370.185 210.936 364.06V308.28C266.06 302.593 309.371 256.656 309.371 200.001V189.064C309.371 182.939 304.559 178.127 298.434 178.127C292.309 178.127 287.497 182.939 287.497 189.064V200.001C287.497 248.344 248.341 287.499 199.999 287.499C179.874 287.499 161.5 280.324 146.603 268.862L162.112 253.353C172.852 260.987 185.977 265.625 199.999 265.625V265.625Z" fill="#FF3D00"/>
        <path d="M119.501 234.126C114.907 223.626 112.501 212.032 112.501 200.001V189.064C112.501 182.939 107.688 178.127 101.563 178.127C95.4386 178.127 90.6262 182.939 90.6262 189.064V200.001C90.6262 218.376 95.2199 235.438 103.095 250.531L119.501 234.126Z" fill="#FF3D00"/>
        </svg>`;
        this.cameraIcon = `<svg width="400" height="400" viewBox="0 0 400 400" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M369.816 113.65C366.622 111.648 362.553 111.45 359.184 113.166L287.5 149.202V123C287.5 104.806 272.778 90 254.688 90H57.8125C39.7219 90 25 104.806 25 123V277C25 295.194 39.7219 310 57.8125 310H254.688C272.778 310 287.5 295.194 287.5 277V250.798L359.163 286.834C362.531 288.528 366.556 288.374 369.794 286.35C373.031 284.348 375 280.806 375 277V123C375 119.194 373.031 115.652 369.816 113.65V113.65Z" fill="white"/></svg>`;
        this.cameraOffIcon = `<svg width="400" height="400" viewBox="0 0 400 400" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M46.4372 307.202L262.121 91.5075C259.715 90.8513 257.309 90.6325 254.684 90.6325H57.812C39.656 90.6325 25 105.289 25 123.446V276.576C25 290.795 33.9686 302.827 46.4372 307.202Z" fill="#FF3D00"/><path d="M359.245 113.602L287.496 149.478V127.974L371.801 43.6654C376.066 39.3997 376.066 32.4651 371.801 28.1993C367.535 23.9336 360.601 23.9336 356.335 28.1993L28.2156 356.335C23.95 360.6 23.95 367.535 28.2156 371.801C32.4811 376.066 39.4154 376.066 43.6809 371.801L106.089 309.389H254.684C272.84 309.389 287.496 294.733 287.496 276.576V250.544L359.245 286.42C363.292 288.148 367.032 287.689 369.745 285.982C373.026 283.795 374.995 280.295 374.995 276.576V123.446C374.995 119.727 373.026 116.227 369.745 114.04C366.682 112.071 362.526 111.852 359.245 113.602V113.602Z" fill="#FF3D00"/></svg>`;
        this.virtualBackgroundIcon = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5.23202 8.25781C4.46478 8.25781 3.84058 8.88201 3.84058 9.64925C3.84058 10.4165 4.46478 11.0407 5.23202 11.0407C5.99926 11.0407 6.62346 10.4165 6.62346 9.64925C6.62346 8.88201 5.99926 8.25781 5.23202 8.25781Z" fill="#fff"/><path d="M1.78434 8.61523C1.21402 8.61523 0.75 9.07921 0.75 9.64953C0.75 10.2199 1.21402 10.6839 1.78434 10.6839C2.35466 10.6839 2.81868 10.2199 2.81868 9.64953C2.81868 9.07921 2.35471 8.61523 1.78434 8.61523Z" fill="#fff"/><path d="M14.35 7.52539C13.1782 7.52539 12.2249 8.4787 12.2249 9.6505C12.2249 10.8223 13.1782 11.7756 14.35 11.7756C15.5217 11.7756 16.475 10.8223 16.475 9.6505C16.475 8.4787 15.5217 7.52539 14.35 7.52539Z" fill="#fff"/><path d="M10.1388 11.7131C11.2808 11.4432 11.9877 10.2986 11.7177 9.15659C11.4478 8.01461 10.3032 7.30769 9.16123 7.57763C8.01926 7.84757 7.31234 8.99216 7.58228 10.1341C7.85222 11.2761 8.99681 11.983 10.1388 11.7131Z" fill="#fff"/><path d="M14.35 12.2246C13.1782 12.2246 12.2249 13.1779 12.2249 14.3497C12.2249 15.5215 13.1782 16.4748 14.35 16.4748C15.5217 16.4748 16.475 15.5215 16.475 14.3497C16.475 13.178 15.5217 12.2246 14.35 12.2246Z" fill="#fff"/><path d="M18.7679 8.25781C18.0007 8.25781 17.3765 8.88201 17.3765 9.64925C17.3765 10.4165 18.0007 11.0407 18.7679 11.0407C19.5351 11.0407 20.1593 10.4165 20.1593 9.64925C20.1593 8.88201 19.5351 8.25781 18.7679 8.25781Z" fill="#fff"/><path d="M22.2157 10.6839C22.7861 10.6839 23.2501 10.2199 23.2501 9.64958C23.2501 9.07925 22.7861 8.61523 22.2157 8.61523C21.6454 8.61523 21.1814 9.07925 21.1814 9.64958C21.1814 10.2199 21.6454 10.6839 22.2157 10.6839Z" fill="#fff"/><path d="M11.1502 15.8521C11.98 15.0223 11.98 13.6769 11.1502 12.8472C10.3204 12.0174 8.97506 12.0174 8.14527 12.8472C7.31549 13.6769 7.31549 15.0223 8.14527 15.8521C8.97506 16.6818 10.3204 16.6818 11.1502 15.8521Z" fill="#fff"/><path d="M5.23202 12.959C4.46478 12.959 3.84058 13.5832 3.84058 14.3504C3.84058 15.1177 4.46478 15.7419 5.23202 15.7419C5.99926 15.7419 6.62346 15.1177 6.62346 14.3504C6.62346 13.5832 5.99926 12.959 5.23202 12.959Z" fill="#fff"/><path d="M1.78434 13.3164C1.21402 13.3164 0.75 13.7804 0.75 14.3508C0.75 14.9211 1.21402 15.3851 1.78434 15.3851C2.35466 15.3851 2.81868 14.9211 2.81868 14.3508C2.81868 13.7804 2.35471 13.3164 1.78434 13.3164Z" fill="#fff"/><path d="M18.7679 12.959C18.0007 12.959 17.3765 13.5832 17.3765 14.3504C17.3765 15.1177 18.0007 15.7419 18.7679 15.7419C19.5351 15.7419 20.1593 15.1177 20.1593 14.3504C20.1593 13.5832 19.5351 12.959 18.7679 12.959Z" fill="#fff"/><path d="M22.2157 13.3164C21.6454 13.3164 21.1814 13.7804 21.1814 14.3507C21.1814 14.9211 21.6454 15.3851 22.2157 15.3851C22.7861 15.3851 23.2501 14.9211 23.2501 14.3508C23.2501 13.7804 22.7861 13.3164 22.2157 13.3164Z" fill="#fff"/><path d="M14.3499 6.62273C15.1172 6.62273 15.7413 5.99853 15.7413 5.23128C15.7413 4.46404 15.1172 3.83984 14.3499 3.83984C13.5827 3.83984 12.9585 4.46404 12.9585 5.23128C12.9585 5.99853 13.5827 6.62273 14.3499 6.62273Z" fill="#fff"/><path d="M18.7679 6.62273C19.5364 6.62273 20.1593 5.99976 20.1593 5.23128C20.1593 4.46281 19.5364 3.83984 18.7679 3.83984C17.9994 3.83984 17.3765 4.46281 17.3765 5.23128C17.3765 5.99976 17.9994 6.62273 18.7679 6.62273Z" fill="#fff"/><path d="M5.23202 17.377C4.46478 17.377 3.84058 18.0012 3.84058 18.7684C3.84058 19.5356 4.46478 20.1598 5.23202 20.1598C5.99926 20.1598 6.62346 19.5356 6.62346 18.7684C6.62346 18.0012 5.99926 17.377 5.23202 17.377Z" fill="#fff"/><path d="M18.7679 17.377C18.0007 17.377 17.3765 18.0012 17.3765 18.7684C17.3765 19.5356 18.0007 20.1598 18.7679 20.1598C19.5351 20.1598 20.1593 19.5356 20.1593 18.7684C20.1593 18.0012 19.5351 17.377 18.7679 17.377Z" fill="#fff"/><path d="M5.23202 3.83984C4.46478 3.83984 3.84058 4.46404 3.84058 5.23128C3.84058 5.99853 4.46478 6.62272 5.23202 6.62272C5.99926 6.62272 6.62346 5.99853 6.62346 5.23128C6.62346 4.46404 5.99926 3.83984 5.23202 3.83984Z" fill="#fff"/><path d="M14.35 2.81868C14.9213 2.81868 15.3844 2.35559 15.3844 1.78434C15.3844 1.21309 14.9213 0.75 14.35 0.75C13.7788 0.75 13.3157 1.21309 13.3157 1.78434C13.3157 2.35559 13.7788 2.81868 14.35 2.81868Z" fill="#fff"/><path d="M14.3499 17.377C13.5827 17.377 12.9585 18.0012 12.9585 18.7684C12.9585 19.5356 13.5827 20.1598 14.3499 20.1598C15.1172 20.1598 15.7413 19.5356 15.7413 18.7684C15.7413 18.0012 15.1172 17.377 14.3499 17.377Z" fill="#fff"/><path d="M14.35 23.2503C14.9213 23.2503 15.3844 22.7872 15.3844 22.216C15.3844 21.6447 14.9213 21.1816 14.35 21.1816C13.7788 21.1816 13.3157 21.6447 13.3157 22.216C13.3157 22.7872 13.7788 23.2503 14.35 23.2503Z" fill="#fff"/><path d="M9.64999 6.62273C10.4172 6.62273 11.0414 5.99853 11.0414 5.23128C11.0414 4.46404 10.4172 3.83984 9.64999 3.83984C8.88274 3.83984 8.25854 4.46404 8.25854 5.23128C8.25854 5.99853 8.88274 6.62273 9.64999 6.62273Z" fill="#fff"/><path d="M9.65006 2.81868C10.2204 2.81868 10.6844 2.35466 10.6844 1.78434C10.6844 1.21402 10.2204 0.75 9.65006 0.75C9.07974 0.75 8.61572 1.21402 8.61572 1.78434C8.61577 2.35466 9.07974 2.81868 9.65006 2.81868Z" fill="#fff"/><path d="M9.64999 17.377C8.88274 17.377 8.25854 18.0012 8.25854 18.7684C8.25854 19.5356 8.88274 20.1598 9.64999 20.1598C10.4172 20.1598 11.0414 19.5356 11.0414 18.7684C11.0414 18.0012 10.4172 17.377 9.64999 17.377Z" fill="#fff"/><path d="M9.65006 21.1816C9.07974 21.1816 8.61572 21.6457 8.61572 22.216C8.61572 22.7863 9.07974 23.2503 9.65006 23.2503C10.2204 23.2503 10.6844 22.7863 10.6844 22.216C10.6844 21.6457 10.2204 21.1816 9.65006 21.1816Z" fill="#fff"/></svg>`;
        this.privacyModeIcon = `<svg width="26" height="28" viewBox="0 0 26 28" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M17.935 1.65251C17.602 0.845512 16.582 0.611512 15.94 1.20551L13.84 3.17952C13.363 3.62652 12.634 3.62652 12.154 3.17952L10.033 1.22951C9.38799 0.635512 8.36799 0.869512 8.03799 1.67651L6.30999 5.91552H19.657L17.935 1.65251ZM2.632 11.0035H23.317C23.98 11.0035 24.19 10.0885 23.608 9.79453L21.073 8.45952H4.89699L2.362 9.79453C1.759 10.0945 1.987 11.0035 2.632 11.0035ZM24.979 18.5785C22.318 17.5165 19.531 16.9465 17.329 16.6075C16.768 16.5235 16.225 16.8415 16.018 17.3485L13.918 22.2055C13.543 23.0575 12.358 23.0575 12.004 22.1845L9.96999 17.3695C9.74199 16.8385 9.20199 16.5205 8.63799 16.6045C6.43299 16.9225 3.64899 17.5165 1.006 18.5755C0.444997 18.7885 0.111998 19.3825 0.237998 19.9945L1.342 26.1026C1.447 26.7176 1.966 27.1226 2.569 27.1226H23.422C24.025 27.1226 24.547 26.6966 24.649 26.1026L25.75 19.9975C25.855 19.4065 25.543 18.8125 24.979 18.5785Z" fill="#fff"/></svg>`;
        this.workingState = ` <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM10 18C5.59 18 2 14.41 2 10C2 5.59 5.59 2 10 2C14.41 2 18 5.59 18 10C18 14.41 14.41 18 10 18ZM14.59 5.58L8 12.17L5.41 9.59L4 11L8 15L16 7L14.59 5.58Z" fill="#44D746"/></svg>`;
        this.nonWorkingState = `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.59 6L10 8.59L7.41 6L6 7.41L8.59 10L6 12.59L7.41 14L10 11.41L12.59 14L14 12.59L11.41 10L14 7.41L12.59 6ZM10 0C4.47 0 0 4.47 0 10C0 15.53 4.47 20 10 20C15.53 20 20 15.53 20 10C20 4.47 15.53 0 10 0ZM10 18C5.59 18 2 14.41 2 10C2 5.59 5.59 2 10 2C14.41 2 18 5.59 18 10C18 14.41 14.41 18 10 18Z" fill="#fc6f6f"/></svg>`;
        this.spinner = `<svg class="circular"><circle class="path" cx="14" cy="14" r="10" fill="none" stroke-width="3" stroke-miterlimit="14" /></svg>`;
        this.noCameraIcon=`<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#fff"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M9.56 8l-2-2-4.15-4.14L2 3.27 4.73 6H4c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h12c.21 0 .39-.08.55-.18L19.73 21l1.41-1.41-8.86-8.86L9.56 8zM5 16V8h1.73l8 8H5zm10-8v2.61l6 6V6.5l-4 4V7c0-.55-.45-1-1-1h-5.61l2 2H15z"/></svg>`;
        this.reconnectionIcon = `<svg class="spinnerLoader"><circle class="pathLoader" cx="50" cy="50" r="30" fill="none" stroke-width="6" stroke-miterlimit="5" /></svg>`;
        this.deviceSettingsIcon = `<svg width="36px" height="28px" viewBox="0 0 36 36" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><path fill="#fff" class="clr-i-outline clr-i-outline-path-1" d="M18.1,11c-3.9,0-7,3.1-7,7s3.1,7,7,7c3.9,0,7-3.1,7-7S22,11,18.1,11z M18.1,23c-2.8,0-5-2.2-5-5s2.2-5,5-5c2.8,0,5,2.2,5,5S20.9,23,18.1,23z"></path><path fill="#fff" class="clr-i-outline clr-i-outline-path-2" d="M32.8,14.7L30,13.8l-0.6-1.5l1.4-2.6c0.3-0.6,0.2-1.4-0.3-1.9l-2.4-2.4c-0.5-0.5-1.3-0.6-1.9-0.3l-2.6,1.4l-1.5-0.6l-0.9-2.8C21,2.5,20.4,2,19.7,2h-3.4c-0.7,0-1.3,0.5-1.4,1.2L14,6c-0.6,0.1-1.1,0.3-1.6,0.6L9.8,5.2C9.2,4.9,8.4,5,7.9,5.5L5.5,7.9C5,8.4,4.9,9.2,5.2,9.8l1.3,2.5c-0.2,0.5-0.4,1.1-0.6,1.6l-2.8,0.9C2.5,15,2,15.6,2,16.3v3.4c0,0.7,0.5,1.3,1.2,1.5L6,22.1l0.6,1.5l-1.4,2.6c-0.3,0.6-0.2,1.4,0.3,1.9l2.4,2.4c0.5,0.5,1.3,0.6,1.9,0.3l2.6-1.4l1.5,0.6l0.9,2.9c0.2,0.6,0.8,1.1,1.5,1.1h3.4c0.7,0,1.3-0.5,1.5-1.1l0.9-2.9l1.5-0.6l2.6,1.4c0.6,0.3,1.4,0.2,1.9-0.3l2.4-2.4c0.5-0.5,0.6-1.3,0.3-1.9l-1.4-2.6l0.6-1.5l2.9-0.9c0.6-0.2,1.1-0.8,1.1-1.5v-3.4C34,15.6,33.5,14.9,32.8,14.7z M32,19.4l-3.6,1.1L28.3,21c-0.3,0.7-0.6,1.4-0.9,2.1l-0.3,0.5l1.8,3.3l-2,2l-3.3-1.8l-0.5,0.3c-0.7,0.4-1.4,0.7-2.1,0.9l-0.5,0.1L19.4,32h-2.8l-1.1-3.6L15,28.3c-0.7-0.3-1.4-0.6-2.1-0.9l-0.5-0.3l-3.3,1.8l-2-2l1.8-3.3l-0.3-0.5c-0.4-0.7-0.7-1.4-0.9-2.1l-0.1-0.5L4,19.4v-2.8l3.4-1l0.2-0.5c0.2-0.8,0.5-1.5,0.9-2.2l0.3-0.5L7.1,9.1l2-2l3.2,1.8l0.5-0.3c0.7-0.4,1.4-0.7,2.2-0.9l0.5-0.2L16.6,4h2.8l1.1,3.5L21,7.7c0.7,0.2,1.4,0.5,2.1,0.9l0.5,0.3l3.3-1.8l2,2l-1.8,3.3l0.3,0.5c0.4,0.7,0.7,1.4,0.9,2.1l0.1,0.5l3.6,1.1V19.4z"></path><rect x="0" y="0" width="36" height="36" fill-opacity="0"/></svg>`
        this.kinoBackIcon=`<?xml version="1.0" encoding="iso-8859-1"?>
        <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
             viewBox="0 0 477.175 477.175" style="enable-background:new 0 0 477.175 477.175;" xml:space="preserve">
            <path d="M145.188,238.575l215.5-215.5c5.3-5.3,5.3-13.8,0-19.1s-13.8-5.3-19.1,0l-225.1,225.1c-5.3,5.3-5.3,13.8,0,19.1l225.1,225
                c2.6,2.6,6.1,4,9.5,4s6.9-1.3,9.5-4c5.3-5.3,5.3-13.8,0-19.1L145.188,238.575z"/>
        </svg>`;
        this.sanitizeOptions = {
            allowedTags: [],
            allowedAttributes: {
                span: [],
                img: [],
            },
            allowedSchemesByTag: {
                img: [],
            },
        };
        this.videoTrack;
        this.audioTrack;
        this.audioMuted=false;
        this.videoMuted=false;
        this.cameraDeviceId=false;
        this.micDeviceId=false;
        this.hasMicSystemDisabled=false;
        this.hasCameraSystemDisabled=false;

        this.vbActive=false;
        this.privacyModeActive=false;
        this.hasAccessToJoin=false;
        this.restricted=RESTRICTED == 1;
        this.role = ROLE;
        this.user_id = USER_ID;
        this.isMember = IS_MEMBER;
        this.allowJoin = ALLOW_JOIN;
        this.allow_guests = ALLOW_GUESTS;
        this.memberData = MEMBER_DATA;
        this.scheduleData = SCHEDULE_DATA;
        this.userEmail = USER_EMAIL;
        this.effectProccessing = false;
        this.audioCapturingInProcess=true;
        this.videoCapturingInProcess=true;
        this.devicesSettings=new DevicesSettings(this);
        this.deviceTroubleshooting=new DeviceTroubleshootingGuide(this, { isMac, isWindows });
        this.deviceCaptureRequestIds={ audio: 0, video: 0 };
        this.isKinoShowroom = IS_SHOWROOM;
        this.session=new Session();
        this._lobbySheetOverlay=null;
        this._sheetTimeout = null;
        this._sheetHoverBound = false;
        this.events();
    }

    events(){
        let l = this;
        //init kinojs
        KinoJS.init(initOptions);
        // console.log('MEMBER_DATA', this.memberData)
        // l.devicesSettings.events();
        // if(l.memberData && l.memberData.is_restricted){
        //     l.kinoIsLocked();
        // }
        // navigator.mediaDevices.ondevicechange = event => {
        //     console.log("Devices list has changed",event)
        //     l.updateDeviceList();
        // }


    }
    updateDeviceList(){
        if(this.devicesSettings.voiceSettingsModal){
            this.devicesSettings.updateDeviceList();
        }
        if(this.wizard && this.wizard.shown){
            this.wizard.deviceListChanged();
        }
    }
    isMod(){
        if(!this.allow_guests && !this.user_id){
            return false;
        }
        return this.role == "moderator";
    }
    isSignedIn(){
        return this.user_id > 0 ? this.user_id : false;
    };

    isJoinAllowed(){
        return this.allow_guests || (this.allowJoin && this.isSignedIn())
    }

    renderLobby(){
        let l = this;
        console.log(isElectron)
        l._sheetHoverBound = false;
        l.lobbySheetContent = $('<div/>', {
            class: 'lobby-toolbox-menu kino-device-sheet-menu lobby-sheet-inner'
        });
        l.lobbyBottomSheet = $('<div/>', {
            id: 'lobby-bottom-sheet',
            class: 'lobby-bottom-sheet'
        }).append(l.lobbySheetContent);
        //Footer container
        l.termsLink = $('<a/>',{
            class: 'footer-link',
            href: isElectron ? `${api.global.app_url}/terms` : '/terms',
            target: '_blank',
            html: 'Terms & Conditions'
        })
        l.privacyLink = $('<a/>',{
            class: 'footer-link',
            href: isElectron ? `${api.global.app_url}/privacy`: '/privacy',
            target: '_blank',
            html: 'Privacy Policy'
        })
        l.footer = $('<div/>',{
            class: 'footer',
            html: ['By entering this Kino you agree to our <br/>', l.termsLink, ' and ', l.privacyLink,'.']
        })

        //Peripherals container
        l.cameraStatusSpan = $('<span/>',{
            class: 'ml-1',
            html: `Allow <b>camera</b> access`
        })
        l.cameraStatus = $('<span/>',{
            class: '',
            html: l.nonWorkingState
        })
        l.cameraStatusContainer = $('<span/>',{
            class: 'check-inputs-style',
            html: [l.cameraStatus, l.cameraStatusSpan]
        })
        l.microphoneStatusSpan = $('<span/>',{
            class: 'ml-1',
            html: `Allow <b>microphone</b> access`
        })
        l.microphoneStatus = $('<span/>',{
            class: '',
            html: l.nonWorkingState
        })
        l.microphoneStatusContainer = $('<span/>',{
            class: 'check-inputs-style',
            html: [l.microphoneStatus, l.microphoneStatusSpan]
        })
        l.peripheralsContainer = $('<div/>',{
            class: 'check-inputs',
            html: [l.microphoneStatusContainer, l.cameraStatusContainer]
        })

        //Privacy mode
        l.privacyModeInput = $('<input/>',{
            class: 'kino-checkbox',
            type: 'checkbox',
        }).on('change', function(){
            if($(this).is(':checked')){
                l.privacyModeIconContainer.addClass('looby-privacy-enabled');
            }else{
                l.privacyModeIconContainer.removeClass('looby-privacy-enabled');
            }
        })
        l.privacyModeSpan = $('<span/>',{
            class: 'input-text',
            html: 'Privacy Mode'
        })
        l.privacyModeIconContainer = $('<span/>',{
            class: 'lobby-button',
            html: l.privacyModeIcon,
        })
        l.privacyModeButton = $('<label/>',{
            class: 'button-inputs',
            id: 'privacy-dropdown-menu-lobby',
            html: [l.privacyModeInput,l.privacyModeIconContainer, l.privacyModeSpan]
        }).on('click',e=>{
            e.preventDefault();
            e.stopPropagation();
            if (l.videoMuted || l.effectProccessing) {
                return false;
            }
            l.togglePrivacyMode();
            l.toggleLobbyBottomSheet('video', () => l.renderVideoMenu());
        })
        l.privacyModeDropdown = $('<div/>',{
            class: 'dropup lobby-menu-dropdown',
            html: [l.privacyModeButton]
        })

        //Virtual background
        l.virtualBackgroundSpan = $('<span/>',{
            class: 'input-text',
            html: 'Virtual Background'
        })
        l.virtualBackgroundIconContainer = $('<span/>',{
            class: 'kino-lobby-vbg',
            html: l.virtualBackgroundIcon,
        })
        l.virtualBackgroundButton = $('<button/>',{
            class: 'button-inputs',
            type: 'button',
            id: 'virtual-background-dropdown-menu-lobby',
            html: [l.virtualBackgroundIconContainer, l.virtualBackgroundSpan]
        }).on('click', function(e){
            e.preventDefault();
            e.stopPropagation();
            l.toggleLobbyBottomSheet('video', () => l.renderVideoMenu());
        })
        l.virtualBackgroundDropdown = $('<div/>',{
            class: 'dropup lobby-menu-dropdown',
            html: [l.virtualBackgroundButton]
        })

        // Device settings
        l.deviceSettingsSpan = $('<span/>',{
            class: 'input-text',
            html: 'Device Settings'
        })
        l.deviceSettingsIconContainer = $('<span/>',{
            class: '',
            html: l.deviceSettingsIcon,
        })
        l.deviceSettingsButton = $('<button/>',{
            class: 'button-inputs',
            html: [l.deviceSettingsIconContainer, l.deviceSettingsSpan]
        }).on('click', function(){
            l.devicesSettings.renderVoiceSettingsModal();
        })

        //Camera
        l.cameraSpan = $('<span/>',{
            class: 'input-text',
            html: 'Video'
        }).on('click', function(){
            l.camera.trigger('click');
        })
        l.cameraInput = $('<input/>',{
            class: 'kino-checkbox',
            type: 'checkbox',
        }).on('change', function(){
            if($(this).is(':checked')){
                l.cameraIconStatus.html(l.cameraOffIcon)
                l.videoMuted=true;
                l.virtualBackgroundButton.attr({'disabled': 'disabled'}).addClass('button-disabled')
                l.privacyModeButton.addClass('button-disabled')
            }else{
                l.cameraIconStatus.html(l.cameraIcon)
                l.videoMuted=false;
                l.virtualBackgroundButton.removeAttr('disabled').removeClass('button-disabled')
                l.privacyModeButton.removeClass('button-disabled')
            }
        })
        l.cameraIconStatus = $('<span/>',{
            html: l.cameraIcon
        })
        l.camera = $('<label/>',{
            class: 'lobby-button mb-0',
            id: 'camera-dropdown-menu-lobby',
            html: [l.cameraInput, l.cameraIconStatus]
        }).on('click',e=>{
            e.preventDefault();
            e.stopPropagation();
            l.toggleCameraMute();
            l.toggleLobbyBottomSheet('video', () => l.renderVideoMenu());
        });
        l.cameraUpperContainer = $('<div/>',{
            class: 'dropup lobby-menu-dropdown d-flex align-items-center',
            html: [l.camera]
        })
        l.cameraContainer = $('<div/>',{
            class: 'button-inputs',
            html: [l.cameraUpperContainer, l.cameraSpan]
        })

        // Microphone
        l.microphoneSpan = $('<span/>',{
            class: 'input-text',
            html: 'Audio'
        }).on('click', function(){
            l.microphone.trigger('click')
        })
        l.microphoneInput = $('<input/>',{
            class: 'kino-checkbox',
            type: 'checkbox',
        }).on('change', function(){
            if($(this).is(':checked')){
                l.microphoneIconStatus.html(l.microphoneOffIcon)
                l.audioMuted=true;
            }else{
                l.microphoneIconStatus.html(l.microphoneIcon);
                l.audioMuted=false;
            }
        })
        l.microphoneIconStatus = $('<span/>',{
            html: l.microphoneIcon
        })
        l.microphone = $('<label/>',{
            class: 'lobby-button mb-0',
            id: 'microphone-dropdown-menu-lobby',
            html: [l.microphoneInput, l.microphoneIconStatus]
        }).on('click',e=>{
            e.preventDefault();
            e.stopPropagation();
            l.toggleAudioMute();
            l.toggleLobbyBottomSheet('audio', () => l.renderAudioMenu());
        });
        l.microphoneUpperContainer = $('<div/>',{
            class: 'dropup lobby-menu-dropdown d-flex align-items-center',
            html: [l.microphone]
        })
        l.microphoneContainer = $('<div/>',{
            class: 'button-inputs',
            html: [l.microphoneUpperContainer, l.microphoneSpan]
        })
        l.bindLobbyBottomSheetHover(l.microphoneUpperContainer, () => l.renderAudioMenu());
        l.bindLobbyBottomSheetHover(l.cameraUpperContainer, () => l.renderVideoMenu());
        l.bindLobbyBottomSheetHover(l.virtualBackgroundDropdown, () => l.renderVideoMenu());
        l.bindLobbyBottomSheetHover(l.privacyModeDropdown, () => l.renderVideoMenu());
        // User customization section
        l.userCustomization = $('<div/>',{
            class: 'inputs-container',
            html: [l.microphoneContainer,l.cameraContainer,l.virtualBackgroundDropdown, l.privacyModeDropdown,l.deviceSettingsButton]
        })
        l.joinActionButton = $('<button/>',{
            class: 'join-button pulse-button',
            html: l.isKinoShowroom ? "ENTER" : l.restricted ? 'REQUEST TO ENTER' : 'ENTER',
            disabled:"disabled"
        }).on('click',function(){
            l.performJoinAction();
        })
        l.emailInputShowroom = $('<input/>',{
            type: 'email',
            class: 'username-input',
            maxlength: '100',
            placeholder: 'Please enter your email',
            style: 'outline: unset !important;',
            value: this.session.getEmail()
        }).on('keyup', function(e){
            if (e.keyCode === 13 && !l.joinActionButton.is(':disabled')) {
                l.performJoinAction();
            }
        })

        const fullname={
            first:'',
            last:''
        };
        if(MY_NAME && MY_NAME.length){
            const nameArray=MY_NAME.split(" ");
            fullname.first=nameArray.shift();
            fullname.last=nameArray.join(' ');
        }

        l.first_name=$('<input/>',{
            type: 'text',
            class: 'username-input',
            maxlength: '100',
            placeholder: 'First name',
            style: 'outline: unset !important;',
            value: fullname.first
        })

        l.last_name=$('<input/>',{
            type: 'text',
            class: 'username-input',
            maxlength: '100',
            placeholder: 'Last name',
            style: 'outline: unset !important;',
            value: fullname.last
        })

        l.fullNameContainer=$("<div/>",{
            class:'d-flex full-name-lobby',
            html:[l.first_name,l.last_name]
        })
        l.nameInput = $('<input/>',{
            type: 'text',
            class: 'username-input',
            maxlength: '100',
            placeholder: 'Please enter your name',
            style: 'outline: unset !important;',
            value: MY_NAME != 'Kino Guest' ? MY_NAME : ''
        }).on('keyup', function(e){
            if (e.keyCode === 13 && !l.joinActionButton.is(':disabled')) {
                l.performJoinAction();
            }
        })
        l.emailInput = $('<input/>',{
            type: 'email',
            class: 'username-input',
            maxlength: '100',
            placeholder: 'Email (Optional)',
            style: 'outline: unset !important;',
            value: USER_EMAIL ? USER_EMAIL : localStorage.getItem("displayEmail")
        })
        l.errors = $('<span/>', {
            class: 'error_kino_lobby text-center',
            html: ''
        })
        l.signInAction = $('<button/>',{
            class: 'subtitle-link px-1',
            type: 'button',
            id: 'sign-in-host',
            html: 'SIGN IN'
        }).on('click', function(){
            l.loginModal.renderModal();
        })
        l.subtitle = $('<span/>',{
            class: 'subtitle',
            html: l.isSignedIn() === false  ? l.isKinoShowroom ? ['Please fill in your name and email address, then press enter. '] : ['If you are the host, a moderator or a member ',l.signInAction,' to get direct access.'] : [`Please type in your name to enter the Kino`]
        })
        l.kinoRoomName = $('<span/>',{
            class: 'room-name-lobby cursor-pointer',
            title: "Copy Link",
            'data-toggle': 'tooltip',
            'data-placement': 'top',
            html: 'Kino ID: ' + ROOM_NAME
        }).on('click', function(e){
            // COPY TO CLIPBOARD
            e.stopPropagation();
            let timeout;
            let domain = window.location.hostname;
            let kinoLink = isElectron ? `${api.global.app_url}/${ROOM_NAME}` : "https://" + domain + "/" + ROOM_NAME;
            navigator.clipboard.writeText(kinoLink);
            $(this).attr("title", "Link Copied");
            $(this).tooltip("show");
            timeout = setTimeout(() => {
                $(this).attr("data-original-title", "Copy link");
                clearTimeout(timeout)
            }, 5000);
        });
        l.title = $('<span/>',{
            class: 'title',
            html: l.isKinoShowroom ? 'Welcome to <span class="orange-text-welcome">Kino</span> Showroom' : l.restricted ? 'This Kino is <span class="orange-text-welcome">Private</span>' : 'Welcome to <span class="orange-text-welcome">Kino</span>',
        })
        l.signInButton = $('<button/>',{
            type: 'button',
            class: 'join-button button-blue-secondary mb-0 mt-0',
            html: 'SIGN IN',
        }).on('click', function(){
            l.loginModal.renderModal();
        })
        l.signOutButton = $('<button/>',{
            type: 'button',
            class: 'join-button mb-3 full-width',
            html: 'SIGN OUT',
        }).on('click', async e=>{
            if(isElectron){
                signOut();
            }else{
                axios.post('/logout').then(res=>window.location.reload());
            }
        })

        let cancelButton=$("<button/>",{
            type: 'button',
            class: 'join-button no-border',
            html: 'CANCEL',
        }).on('click',function(){
            location.href=api.global.dirname+'src/html/pages/welcome.ejs';
        })
        l.signUpButton = $('<button/>',{
            type: 'button',
            class: 'join-button mb-0 mt-0',
            html: 'SIGN UP'
        }).on('click', function(){
            if(isElectron){
                // we have to add functionality for desktop to open the side drawer with the sign up page
                window.open(`${api.global.app_url}/signup`, '_blank');
            }else{
                window.location.replace('/signup');
            }
        });

        l.requestActions = $('<div/>',{
            class: 'request-actions',
            html: [
                l.isKinoShowroom && !permissions.isMod() ? l.fullNameContainer : l.nameInput,
                (!l.isKinoShowroom && this.isSignedIn() && permissions.canJoinKino()) ?  l.emailInput : "",
                l.isKinoShowroom && !permissions.isMod() ? l.emailInputShowroom : "",
                l.joinActionButton
            ]
        })

        l.errorMessageContainer=$('<div/>',{
            class:'lobby-error-messages',
            html:[l.errors, l.deviceTroubleshooting.inlineAlert]
        });
        l.verificationContainer = $('<div/>',{
            class: 'verification',
            html: [
                l.title,
                l.isKinoShowroom ? '' : l.kinoRoomName,
                l.subtitle,
                l.requestActions,
                l.errorMessageContainer,
                l.userCustomization,
                l.peripheralsContainer,
            ]
        })
        l.kinoLogoContainer = $('<span/>',{
            class: 'cursor-pointer kino-logo-container',
            html: l.kinoLogo
        }).on('click', function(){
            if(isElectron){
                location.href=api.global.dirname+'src/html/pages/welcome.ejs';
            }else{
                location.href = '/'
            }
        });
        let backIcon=$("<div/>",{
            class:"kino-back-icon",
            html:l.kinoBackIcon
        })
        let backButton=$("<div/>",{
            class:"kino-back-button",
            html:[backIcon,"Back"]
        }).on("click",function(){
            location.href=api.global.dirname+'src/html/pages/welcome.ejs';
        });
        let header=$("<div/>",{
            class:"welcome-page-header",
            html:backButton
        })
        l.actionsContainer = $('<div/>',{
            class: 'validation-section col-md-5',
            html: [isElectron ?  header : '',l.kinoLogoContainer, l.verificationContainer, l.footer]
        })
        l.localVideoPreview=document.createElement('video');
        l.localVideoPreview.autoplay=1;
        l.localVideoPreview.classList.add('flipVideoX');
        l.localVideoPreview.oncanplay=(event)=>{
            l.localVideoPreview.play();
        };
        l.noCameraImage=$('<div/>',{
            class: 'no-cam-layer-background mb-2',
            html: l.noCameraIcon
        });

        l.noCameraIconContainer=$("<div/>",{
            class:'no-cam-icon-container',
            html:[l.noCameraImage]
        });
        l.noCameraMessage=$('<div/>',{
            class:'lobby-no-camera-message mt-3',
            html:'Please <b>Allow</b> Kino use of the camera and microphone'
        });
        l.noCameraLayer=$("<div/>",{
            class:"no-camer-layer-thumbnail lobby",
            html:[l.noCameraIconContainer,l.noCameraMessage,l.deviceTroubleshooting.previewAction]
        });

        l.cameraPreviewContainer = $('<div/>',{
            class: 'video-section',
            html: [l.localVideoPreview,l.noCameraLayer]
        })


        l.innerContainer = $('<div/>',{
            class: 'row',
            html: [l.actionsContainer, l.cameraPreviewContainer]
        })
        l.lobby = $('<div/>',{
            class: 'lobby-container-kino',
            html: [l.innerContainer, l.lobbyBottomSheet]
        })

        //check before appending the overlay if user is signed in or not
        // l.kinoIsLocked();
        // if((!l.isJoinAllowed() && !l.isMod()) || (l.memberData && l.memberData.is_restricted && !l.isMember)){
        //     l.kinoIsLocked();
        // }
        // try {
        //     if(!l.isSignedIn() && OPEN_MODAL){
        //         if(OPEN_MODAL=="signin"){
        //             l.loginModal.renderModal();
        //         }else if(OPEN_MODAL=="signup"){
        //             if(isElectron){
        //                 // we have to add functionality for desktop to open the side drawer with the sign up page
        //                 window.open(`${api.global.app_url}/signup`, '_blank');
        //             }else{
        //                 window.location.replace('/signup');
        //             }
        //         }
        //     }
        // } catch (error) {
        //     console.error(error);
        // }
        // $('body').append(l.lobby)
        // l.removeConnectingScreen();
        // l.onLobbyShown();
        this.showLobbyAfterPermission();
    }

    verifyEnteredEmail(){
        const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        let l = this;
        let enteredEmail = l.emailInputShowroom.val();
        if(!enteredEmail){
            l.setMessage('Email address is required');
            return false;
        }
        if(!re.test(enteredEmail)){
            l.setMessage('A valid email address is required');
            return false;
        }
        return true;
    }

    showLobbyAfterPermission(){
        const l=this;
        permissions.getRolePermisions().then(data=>{
            if(!permissions.isAvailable()){
                l.kinoNotAvailable();
                $('body').append(l.lobby)
                l.removeConnectingScreen();
                return
            }
            if(!permissions.canJoinKino()){
                l.kinoIsLocked();
            }else{
                l.joinActionButton.html(l.isKinoShowroom ? "ENTER" : permissions.shouldRequestToJoin() ? 'REQUEST TO ENTER' : 'ENTER');
                l.title.html(l.isKinoShowroom ? 'Welcome to <span class="orange-text-welcome">Kino</span> Showroom' : permissions.shouldRequestToJoin() ? 'This Kino is <span class="orange-text-welcome">Private</span>' : 'Welcome to <span class="orange-text-welcome">Kino</span>')
            }
            try {
                if(!l.isSignedIn() && OPEN_MODAL){
                    if(OPEN_MODAL=="signin"){
                        l.loginModal.renderModal();
                    }else if(OPEN_MODAL=="signup"){
                        if(isElectron){
                            window.open(`${api.global.app_url}/signup`, '_blank');
                        }else{
                            window.location.replace('/signup');
                        }
                    }
                }
            } catch (error) {
                console.error(error);
            }
            $('body').append(l.lobby)
            l.removeConnectingScreen();
            l.onLobbyShown();
        });
    }
    onLobbyShown(){
        this.testInputDevices();
        if(!this.wasDevicesModalShownBefore()){
            // this.devicesSettings.renderVoiceSettingsModal();
        }
    };
    removeLobbyOverlay(){
        let l = this;
        if(l.lobby){
            l.localVideoPreview.srcObject=null;
            l.lobby.remove();
        }
    }

    userGotRejected(){
        let l = this;
        if(l.joinActionButton){
            l.joinActionButton.remove();
        }
        l.removeJoiningOverlay();
        // if(kinoLimits.isModalShown()){
        //     kinoLimits.setMessage('Your request to join this Kino has been rejected',true);
        // }
        l.setMessage('Your request to join this Kino has been rejected');
    }

    verifyEnteredName(){
        let l = this;
        if(l.isKinoShowroom && !permissions.isMod()){
            let first = sanitizeHtml(l.first_name.val(), l.sanitizeOptions);
            let last  = sanitizeHtml(l.last_name.val(), l.sanitizeOptions);
            let email = l.emailInput.val()

            first = first.trim();
            last = last.trim()
            if (first.length == 0 || last.length == 0) {
                l.setMessage('Please enter your full name');
                return false;
            }
            MY_NAME = first+" "+last;
            Cookies.set("displayName", MY_NAME, {
                expires: 365,
            });
            if(isElectron){
                localStorage.setItem('displayName',MY_NAME)
            }
        }else{
            let enteredName = l.nameInput.val();
                enteredName = sanitizeHtml(enteredName, l.sanitizeOptions);
                enteredName = enteredName.trim();
            if (enteredName.length < 2) {
                l.setMessage('Please enter a name with a minimum of 2 characters');
                return false;
            }
            MY_NAME = enteredName;
            if(isElectron){
                localStorage.setItem('displayName',enteredName)
            }
            Cookies.set("displayName", enteredName, {
                expires: 365,
            });
        }
        return true;
    }
    async requestAccess(){
        let l = this;
        if(!this.verifyEnteredName() || !permissions.isAvailable()){
            return;
        }
        l.disableJoinButton();
        joinRequest.addResponseListener();
        if(!await l.kinoAvailability())return;
        if(kinoLimits.isParticipantLimitReached()){
            l.limitReached();
        }
        joinRequest.onAccept=()=>{
            l.hasAccessToJoin=true;
            l.joinKino();
        };
        joinRequest.onReject=()=>{
            l.userGotRejected();
        };
        let data = {
            user_id: USER_ID,
            guestId: GUEST_ID,
            participant: "",
            displayName: MY_NAME,
            room_id: ROOM_NAME,
            role: ROLE,
        };

        joinRequest.sendJoinRequest(data);
        l.setMessage('');
        // if(kinoLimits.isParticipantLimitReached()){
        //   kinoLimits.showParticipantLimitModal(true);
        //   l.removeLobbyOverlay();
        // }
      deviceManager.clearErrorMessages();
    }

   async performJoinAction(){
        if(!this.verifyEnteredName() || !permissions.isAvailable()){
            return;
        }
        let enteredEmail = this.emailInput.val()
        localStorage.setItem("displayEmail", enteredEmail)
        if(this.isKinoShowroom && !this.verifyEnteredEmail() && !permissions.isMod()){
            return;
        }

        let localTracks=this.tracksToArray();
        if(!localTracks.find(t=>t.getType()=="audio")){
            this.setMessage("Please connect a microphone to continue");
            return;
        }
        this.disableJoinButton();
        if(this.isKinoShowroom && !permissions.isMod()){
            this.session.setEmail(this.emailInputShowroom.val())
            this.submitLead(this.first_name.val(),this.last_name.val(),this.emailInputShowroom.val())
        }
        if(!socket.connected){
            console.log("socket not connected")
            this.showJoiningOverlay('Waiting for a connection...');
            socket.events.lobbyOnConnection=()=>{
                socket.events.lobbyOnConnection=false;
                hasDeviceAccessToContinue().then(()=>{
                    if(permissions.shouldRequestToJoin() || kinoLimits.isParticipantLimitReached()){
                        this.requestAccess();
                    }else{
                        this.joinKino();
                    }
                }).catch(()=>{
                    this.enableJoinButton();
                    this.removeJoiningOverlay();
                })
            };
        }else{
            hasDeviceAccessToContinue().then(()=>{
                if(permissions.shouldRequestToJoin() || kinoLimits.isParticipantLimitReached()){
                    this.requestAccess();
                }else{
                    this.joinKino();
                }
            }).catch(()=>{
                this.enableJoinButton();
            })
        }
    }

    submitLead(first,last,email){
        axios.post(convertPath('/lead/create'),{
            'first_name':first,
            'last_name':last,
            'email':email,
            'reference': "Showroom Opened"
        }).then(r=>{
            console.log("email submited",r.data)
        })
    }
    enableJoinButton() {
        let l = this;
        l.joinActionButton.attr("disabled", false);
        l.joinActionButton.html(`${l.isKinoShowroom ? "ENTER" : permissions.shouldRequestToJoin() ? 'REQUEST TO ENTER' : 'ENTER'}`);
        l.nameInput.removeAttr('readonly')
        l.first_name.removeAttr('readonly')
        l.last_name.removeAttr('readonly')
    }
    disableJoinButton() {
        let l = this;
        const loadingLabel = permissions.shouldRequestToJoin() ? 'REQUESTING...' : 'ENTERING...';
        l.joinActionButton.attr("disabled", "disabled");
        l.joinActionButton.html(`${l.spinner} ${loadingLabel}`);
        l.nameInput.attr('readonly',1)
        l.first_name.attr('readonly',1)
        l.last_name.attr('readonly',1)
    }

    disableJoinActionButton(){
        this.joinActionButton.attr("disabled", "disabled");
    };
    enableJoinActionButton(){
        this.joinActionButton.removeAttr("disabled");
    };

    shouldEnableActionButton(){
        if(!this.audioCapturingInProcess && !this.videoCapturingInProcess){
            this.enableJoinActionButton();
        }
    };
    kinoIsLocked(){
        let l = this;
        l.isLocked=true;
        let signedInMessage = `The Kino account ${l.userEmail} is not a verified member of this Kino. To access this Kino, please follow the information provided in the invitation email you received, or verify with the host your Kino account is a verified member.`;
        let guestMessage = `The access to this Kino is for verified members only. Please sign in with your Kino account. If your email address is a verified member of this Kino you'll be able to join.`;
        l.title.html('This Kino is <span class="orange-text-welcome">Private</span>');
        let notTeamMemberMessage=`The Kino account ${l.userEmail} is not a verified team member. Please check you account page at Kino.live and accept the invitation to be able to join this workspace.`;
        if(permissions.isWorkspace && l.isMember && !permissions.isVerifiedMember()){
            l.subtitle.html(`<span class="error_kino_lobby">Access Denied</span><br><br>${notTeamMemberMessage}`);
        }else if(l.memberData && l.memberData.action && l.memberData.action == "switch_account"){
            l.subtitle.html(`<span class="error_kino_lobby">Access Denied</span><br><br>${l.memberData.message }`);
        }else if (l.memberData && l.memberData.action && (l.memberData.action == "signin" || l.memberData.action == "signup")){
            l.subtitle.html( l.memberData.message );
        }else if (l.isSignedIn() && !l.isMember){
            l.subtitle.html(`<span class="error_kino_lobby">Access Denied</span><br><br>${signedInMessage}`);
        }else if (!l.isSignedIn()){
            l.subtitle.html(guestMessage);
        }
        l.nameInput.remove();
        l.fullNameContainer.remove();
        l.joinActionButton.remove();
        if(l.isSignedIn()){
            l.requestActions.prepend(l.signOutButton);
        }else{
            l.requestActions.prepend(l.signInButton, l.signUpButton);
            l.requestActions.addClass('buttons-row');
        }

    }
    kinoNotAvailable(){
        let l = this;
        l.isLocked=true;
        l.title.html('This Kino is not available');
        const message=`This Kino is currently unavailable.`;
        l.subtitle.html(message);
        l.nameInput.remove();
        l.joinActionButton.remove();
        if(l.isSignedIn()){
            l.requestActions.prepend(l.signOutButton);
        }else{
            l.requestActions.prepend(l.signInButton, l.signUpButton);
        }
    }

    async kinoAvailability(){
        const l = this;
        if(!(l.scheduleData && l.scheduleData.schedule)){
            clearTimeout(l.automaticJoinTimeout);
            return true;
        }
        clearTimeout(l.automaticJoinTimeout);
        const requestId = ++l._availabilityRequestId;
        try {
            const res = await axios.get(
                convertPath(`/kino/${ROOM_NAME}/availability`),
                {
                    ...(await electronConfig()),
                    params: { guest_id: typeof GUEST_ID !== 'undefined' ? GUEST_ID : undefined },
                    timeout: 5000
                }
            );
            if(requestId !== l._availabilityRequestId){
                return false;
            }
            const data = res.data || {};
            if(data.available){
                return true;
            }
            const when = data.joins_at || data.starts_at;
            animatedLayers.showScheduledKinoInfo(l.formatLocalScheduleDate(when), l.restricted);
            const retryMs = Number(data.retry_after_seconds) > 0
                ? Number(data.retry_after_seconds) * 1000
                : 10000;
            l.automaticJoinTimeout = setTimeout(() => {
                l.performJoinAction();
            }, retryMs);
            return false;
        } catch (err) {
            if(requestId !== l._availabilityRequestId){
                return false;
            }
            console.error(err);
            const fallback = l.scheduleData.schedule_info_start_time_text
                || l.scheduleData.schedule_join_time;
            animatedLayers.showScheduledKinoInfo(l.formatLocalScheduleDate(fallback), l.restricted);
            l.automaticJoinTimeout = setTimeout(() => {
                l.performJoinAction();
            }, 10000);
            return false;
        }
    };

    formatLocalScheduleDate(dateData){
        if(!dateData){
            return '';
        }
        const local = moment(dateData).local();
        if(!local.isValid()){
            return String(dateData);
        }
        return local.format('dddd, MMMM D YYYY [at] h:mm A');
    }
    hideEmail(email){
        if(email){
            let hide = email.split("@")[0].length - 1;//<-- number of characters to hide
            var r = new RegExp(".{"+hide+"}@", "g")
            email = email.replace(r, "***@" );
            return email;
        }
    }
    limitReached(){
        let l = this;
        // l.title.html('Participants limit reached');
        // l.subtitle.html('This Kino has reached the limit of participants. Please wait, you will be able to enter on kino as soon as someone leaves');
        l.showJoiningOverlay('This Kino has reached the limit of participants. <br/> Please wait, you will be able to enter on kino as soon as someone leaves', true, 'Participants limit reached');
    };

    testInputDevices(retry=true){
        deviceManager.getAudioVideoTrack().then(tracks=>{
            let audioTrack=tracks.find(t=>t.getType()=="audio");
            let videoTrack=tracks.find(t=>t.getType()=="video");

            if(audioTrack){
                this.audioCapturingInProcess=false;
                this.shouldEnableActionButton();
                this.audioTrack=audioTrack;
                this.micDeviceId=audioTrack.deviceId;
                deviceManager.saveMic(audioTrack.deviceId,audioTrack.track.label);
                if(this.audioMuted){
                    this.audioTrack.mute();
                }
                console.log('[MIC-DIAG] KinoLobby.testInputDevices:audio', {
                    audioMuted: this.audioMuted,
                    trackMuted: this.audioTrack?.isMuted?.(),
                });
                this.setMicrophoneOn();
            }else{
                //no audio track
                this.audioCapturingInProcess=false;
                this.shouldEnableActionButton();
                this.setMicrophoneOff();
            }

            if(videoTrack){
                this.videoCapturingInProcess=false;
                this.shouldEnableActionButton();
                console.log("Success getting camera track",videoTrack);
                this.localVideoPreview.srcObject=videoTrack.stream;
                this.cameraDeviceId=videoTrack.deviceId;
                deviceManager.saveCamera(videoTrack.deviceId,videoTrack.track.label);
                this.videoTrack=videoTrack;
                this.setCameraOn();
            }else{
                //no video track
                this.videoCapturingInProcess=false;
                this.shouldEnableActionButton();
                this.setCameraOff({name:""});
            }
            if((!this.wasDevicesWizardShown() || deviceManager.areDevicesChanged({id:this.micDeviceId,label:audioTrack.track.label},videoTrack ? {id:this.cameraDeviceId,label:videoTrack.track.label} : false)) && !this.wizard?.shown && !this.isLocked){
                this.wizard=new DeviceWizard(this);
                this.wizard.showWizard();
            }
        }).catch(err=>{
            console.error(err)
            if(err && (err.name=="OverconstrainedError" || err.name=="gum.constraint_failed") && retry){
                const fallback = this.micDeviceId === 'communications' ? 'default' : this.micDeviceId==='default' ? this.micDeviceId : 'communications'
                console.log("retrying device with fallback",fallback)
                deviceManager.saveCamera('default','');
                deviceManager.saveMic(fallback,'');
                setTimeout(() => {
                   this.testInputDevices(false);
                }, 20);
                return;
            }else{
                const fallback = this.micDeviceId === 'communications' ? 'default' : this.micDeviceId==='default' ? this.micDeviceId : 'communications'
                this.tryMicrophoneDevice(fallback,true);
                this.tryCameraDevice(this.cameraDeviceId);
            }
            this.audioCapturingInProcess=false;
            this.videoCapturingInProcess=false;
            this.shouldEnableActionButton();
        });
    };

    tryMicrophoneDevice(id,retry=false){
        const requestId=++this.deviceCaptureRequestIds.audio;
        this.micDeviceId=id;
        deviceManager.getAudioTrack(id).then(audioTrack=>{
            if(requestId!==this.deviceCaptureRequestIds.audio){
                audioTrack.forEach(track=>this.devicesSettings.stopTracks(track));
                return;
            }
            if(this.audioTrack){
                this.devicesSettings.stopTracks(this.audioTrack);
            }
            this.audioTrack=audioTrack[0];
            this.micDeviceId=audioTrack[0].deviceId;
            this.audioMuted=false;
            deviceManager.saveMic(audioTrack[0].deviceId,audioTrack[0].track.label);
            this.deviceTroubleshooting.clearError('audio');
            connection || this.setMicrophoneOn();
        }).catch(err=>{
            if(requestId!==this.deviceCaptureRequestIds.audio){
                return;
            }
            console.error(err.name)
            if(err.name=='gum.constraint_failed' && retry){
                const fallback = id === 'communications' ? 'default' : id==='default' ? id : 'communications'
                deviceManager.saveMic(fallback,'');
                this.tryMicrophoneDevice(fallback,false);
                if((!this.wizard || (this.wizard && this.wizard.shown)) && !isJoined){
                    this.wizard=new DeviceWizard(this);
                    this.wizard.showWizard();
                }
            }else{
                this.setMicrophoneOff(err);
            }
        });
    }

    tryCameraDevice(id){
        const requestId=++this.deviceCaptureRequestIds.video;
        this.cameraDeviceId=id;
        deviceManager.getCameraTrack(id).then(async cameraTracks=>{
            if(requestId!==this.deviceCaptureRequestIds.video){
                cameraTracks.forEach(track=>this.devicesSettings.stopTracks(track));
                return;
            }
            console.log("Success getting camera track",cameraTracks[0]);
            this.cameraDeviceId=cameraTracks[0].deviceId;
            deviceManager.saveCamera(cameraTracks[0].deviceId,cameraTracks[0].track.label);

            if(this.vbActive){
                vb.effect=this.vbActive;
                cameraTracks[0]=await vb.runEffect(cameraTracks[0]);
            }
            if(requestId!==this.deviceCaptureRequestIds.video){
                cameraTracks.forEach(track=>this.devicesSettings.stopTracks(track));
                return;
            }
            if(this.videoTrack){
                this.devicesSettings.stopTracks(this.videoTrack);
            }
            this.videoTrack=cameraTracks[0];
            this.localVideoPreview.srcObject=cameraTracks[0].stream;
            this.setCameraOn();
        }).catch(err=>{
            if(requestId!==this.deviceCaptureRequestIds.video){
                return;
            }
            console.error(err.message);
            if(err.message == "Could not start video source"){
                deviceManager.getNextAvailableCamera().then(next=>{
                    console.log("Next camera to try",next.deviceId)
                    this.tryCameraDevice(next.deviceId);
                });
            }
            this.setCameraOff(err);
            if((!this.wizard || (this.wizard && !this.wizard.shown)) && !isJoined){
                this.wizard=new DeviceWizard(this);
                this.wizard.showWizard();
            }
        })
    };

    getMicrophoneList(){
        this.renderAudioMenu();
    };

    getCameraList(){
        this.renderVideoMenu();
    };

    buildDeviceSheetHeader(title) {
        return $('<div/>', {
            class: 'kino-device-sheet-header',
            html: [
                $('<div/>', { class: 'kino-device-sheet-handle' }),
                $('<div/>', { class: 'kino-device-sheet-title', html: title })
            ]
        });
    };

    buildDeviceSectionTitle(title, extraClass = '') {
        return `<h6 class="dropdown-header kino-device-section-title ${extraClass}">${title}</h6>`;
    };

    isLobbyBottomSheetVisible() {
        return this.lobbyBottomSheet.hasClass('lobby-bottom-sheet--visible');
    };

    showLobbyBottomSheet() {
        this.lobbyBottomSheet.addClass('lobby-bottom-sheet--visible');
    };

    hideLobbyBottomSheet() {
        this.lobbyBottomSheet.removeClass('lobby-bottom-sheet--visible');
        this._lobbySheetKind = null;
        try {
            if (this.sheetTestMeters) {
                this.sheetTestMeters.teardown();
                this.sheetTestMeters = null;
            }
        } catch (error) {
            console.error('[Kino] lobby sheet testers teardown error', error);
        }
    };

    toggleLobbyBottomSheet(kind, renderMenu) {
        if (this.isLobbyBottomSheetVisible() && this._lobbySheetKind === kind) {
            this.hideLobbyBottomSheet();
            return;
        }
        renderMenu();
        this.showLobbyBottomSheet();
    };

    bindLobbyBottomSheetHover($wrapper, renderMenu, canOpen = () => true) {
        $wrapper.on('mouseenter', () => {
            if (!canOpen()) return;
            renderMenu();
            this.showLobbyBottomSheet();
        });

        if (!this._sheetDismissBound) {
            this._sheetDismissBound = true;
            $(document).on('click.lobbyDeviceSheet', (event) => {
                if (!this.isLobbyBottomSheetVisible()) {
                    return;
                }
                if ($(event.target).closest('#lobby-bottom-sheet, .lobby-menu-dropdown').length) {
                    return;
                }
                this.hideLobbyBottomSheet();
            });
        }
    };

    renderAudioMenu(){
        let l = this;
        if (!navigator.mediaDevices || !navigator.mediaDevices.enumerateDevices) {
            console.log("enumerateDevices() not supported.");
        }

        const audioListContainer = $('<div/>', {
            class: 'audio-list-container-scrollable'
        });
        l._lobbySheetKind = 'audio';
        l.lobbySheetContent
            .html([l.buildDeviceSheetHeader('Audio'), audioListContainer]);

        KinoJS.mediaDevices.enumerateDevices((devices) => {
            const selectedSpeaker = deviceManager.lastUsedSpeaker();
            const lastUsedMic = deviceManager.lastUsedMic();
            const rawMics = devices.filter(d => d.kind === 'audioinput');
            const rawSpeakers = devices.filter(d => d.kind === 'audiooutput');

            const sortedMics = sortDevicesByRecency(rawMics, l.micDeviceId, lastUsedMic);
            const sortedSpeakers = sortDevicesByRecency(
                rawSpeakers,
                selectedSpeaker,
                null
            );

            audioListContainer.html(l.buildDeviceSectionTitle('Microphone devices'));
            sortedMics.forEach(device => {
                const label = device.label || device.deviceId;
                const selected = l.micDeviceId === device.deviceId ? 'selected' : '';
                const option = $('<button/>', {
                    type: 'button',
                    class: `dropdown-item kino-device-row audio-input-device ${selected}`,
                    'device-id': device.deviceId,
                    html: [`<i class="fas fa-microphone mr-1"></i>`, `<span class="ellipsis">${label}</span>`]
                }).on('click', e => {
                    e.preventDefault();
                    e.stopPropagation();
                    l.tryMicrophoneDevice(device.deviceId);
                });
                audioListContainer.append(option);
            });

            const outputDevices = sortedSpeakers.map(device => {
                const label = device.label || device.deviceId;
                const selected = selectedSpeaker === device.deviceId || (!selectedSpeaker && device.deviceId === 'communications') ? 'selected' : '';
                return $('<button/>', {
                    type: 'button',
                    class: `dropdown-item kino-device-row audio-output-device ${selected}`,
                    'device-id': device.deviceId,
                    html: [`<i class="fas fa-volume-up mr-1"></i>`, `<span class="ellipsis">${label}</span>`]
                }).on('click', e => {
                    e.preventDefault();
                    e.stopPropagation();
                    deviceManager.saveSpeaker(device.deviceId);
                    l.renderAudioMenu();
                });
            });

            audioListContainer.append(l.buildDeviceSectionTitle('Speaker devices', 'mt-3'));
            audioListContainer.append(outputDevices);

            const muteMicButton = $('<button/>', {
                type: 'button',
                class: `dropdown-item kino-device-footer-action audio-input-device dropdown-action ${l.audioMuted ? '' : 'action-mute'}`,
                html: [``, `<span class="ellipsis">${l.audioMuted ? 'Unmute' : 'Mute'} microphone</span>`]
            }).on('click', e => {
                e.preventDefault();
                e.stopPropagation();
                l.toggleAudioMute();
                l.renderAudioMenu();
            });
            l.lobbySheetContent.append($('<div/>', {
                class: 'lobby-device-settings-container',
                html: [
                    l.buildDeviceSectionTitle('Audio settings', 'mt-3'),
                    muteMicButton,
                    l.deviceTroubleshooting.buildSheetAction('audio')
                ]
            }));

            l.mountSheetTesters('audio');
        });
    };

    mountSheetTesters(kind){
        let l = this;
        try {
            if (l.sheetTestMeters) { l.sheetTestMeters.teardown(); }
            l.sheetTestMeters = new DeviceTestMeters({
                testSoundSrc: `${isElectron ? api.global.app_url : ''}/sounds/test-output.mp3`
            });
            if (kind === 'audio') {
                l.sheetTestMeters.mountAudioSheet(l.lobbySheetContent);
            } else {
                l.sheetTestMeters.mountVideoSheet(l.lobbySheetContent);
            }
        } catch (error) {
            console.error('[Kino] lobby sheet testers mount error', error);
        }
    };

    renderVideoMenu(){
        let l = this;
        if (!navigator.mediaDevices || !navigator.mediaDevices.enumerateDevices) {
            console.log("enumerateDevices() not supported.");
        }

        const cameraListContainer = $('<div/>', {
            class: 'camera-list-container-scrollable'
        });
        l._lobbySheetKind = 'video';
        l.lobbySheetContent
            .html([l.buildDeviceSheetHeader('Video'), cameraListContainer]);

        KinoJS.mediaDevices.enumerateDevices((devices) => {
            const lastUsedCamera = deviceManager.lastUsedCamera();
            const rawCameras = devices.filter(d => d.kind === 'videoinput');
            const sortedCameras = sortDevicesByRecency(rawCameras, l.cameraDeviceId, lastUsedCamera);

            cameraListContainer.html(l.buildDeviceSectionTitle('Camera devices'));
            sortedCameras.forEach(device => {
                const label = device.label || device.deviceId;
                const selected = l.cameraDeviceId === device.deviceId ? 'selected' : '';
                const option = $('<button/>', {
                    type: 'button',
                    class: `dropdown-item kino-device-row video-input-device ${selected}`,
                    'device-id': device.deviceId,
                    html: [`<i class="fas fa-video mr-1"></i>`, `<span class="ellipsis">${label}</span>`]
                }).on('click', e => {
                    e.preventDefault();
                    e.stopPropagation();
                    if (!l.videoMuted) {
                        l.tryCameraDevice(device.deviceId);
                    }
                });
                cameraListContainer.append(option);
            });

            l.lobbySheetContent.append(l.buildLobbyVbPicker());

            l.lobbySheetContent.append($('<div/>', {
                class: 'camera-settings-container',
                html: [
                    l.buildDeviceSectionTitle('Video settings', 'mt-3'),
                    $('<button/>', {
                        type: 'button',
                        class: `dropdown-item kino-device-footer-action video-input-device dropdown-action ${l.videoMuted ? '' : 'action-mute'}`,
                        html: [``, `<span class="ellipsis">${l.videoMuted ? 'Unmute' : 'Mute'} camera</span>`]
                    }).on('click', e => {
                        e.preventDefault();
                        e.stopPropagation();
                        l.toggleCameraMute();
                        l.renderVideoMenu();
                    }),
                    l.deviceTroubleshooting.buildSheetAction('video')
                ]
            }));

            l.mountSheetTesters('video');
        });
    };

    buildLobbyVbPicker(){
        let l = this;
        const picker = $('<div/>', {
            class: 'kino-vb-picker',
            html: [l.buildDeviceSectionTitle('Virtual Background', 'mt-3')]
        });
        const tileList = $('<div/>', { class: 'kino-vb-tile-list' });
        const errorMessage = $('<div/>', { class: 'kino-vb-picker-error' });
        const disabled = !l.videoTrack || l.videoMuted || l.effectProccessing;

        const buildTiles = () => {
            tileList.empty();
            const selectedId = vb.activeMobilePickerBackgroundId();

            vb.mobilePickerBackgrounds().forEach(background => {
                const selected = selectedId == background.id;
                let preview;

                if (background.type === 'image') {
                    preview = `<img src="${background.location}" alt="">`;
                } else if (background.type === 'blur' || background.type === 'privacy') {
                    preview = background.location;
                } else if (background.type === 'custom-pick') {
                    preview = '<span class="kino-vb-plus">+</span>';
                } else if (background.type === 'none') {
                    preview = noVirtualBackgroundIcon();
                } else {
                    preview = '<i class="fas fa-video-slash"></i>';
                }

                const tile = $('<button/>', {
                    type: 'button',
                    class: `kino-vb-tile ${selected ? 'selected' : ''}`,
                    html: [
                        $('<span/>', { class: 'kino-vb-tile-preview', html: preview }),
                        $('<span/>', { class: 'kino-vb-tile-label', html: background.name })
                    ]
                }).on('click', async e => {
                    e.preventDefault();
                    e.stopPropagation();
                    errorMessage.html('');
                    if (!l.videoTrack || l.videoMuted) {
                        errorMessage.html('Turn on your camera to use virtual backgrounds');
                        return;
                    }
                    if (l.effectProccessing) return;

                    if (background.type === 'custom-pick') {
                        vb.pickMobilePickerBackground(
                            () => buildTiles(),
                            msg => errorMessage.html(msg)
                        );
                        return;
                    }

                    if (background.type === 'privacy') {
                        if (!l.privacyModeActive) {
                            await l.startPrivacyMode();
                        }
                        l.renderVideoMenu();
                        return;
                    }

                    await l.onVirtualBackgroundSet(background.type === 'none' ? false : background);
                    l.renderVideoMenu();
                });

                tileList.append(tile);
            });
        };

        buildTiles();
        picker.append(tileList, errorMessage);
        if (disabled) {
            picker.addClass('kino-vb-picker-disabled');
        }
        return picker;
    };

    setMicrophoneOff(error=false){
        this.microphoneInput.prop('checked',true).trigger('change');
        this.microphoneStatus.html(this.nonWorkingState);
        // this.microphoneStatusSpan.html(`Your <b>microphone</b> is not working properly`)
        if(error){
            this.micErrorHandler(error);
        }
    };
    setCameraOff(error=false){
        this.cameraInput.prop('checked',true).trigger('change');
        this.cameraStatus.html(this.nonWorkingState);
        this.cameraStatusSpan.html(`Your <b>camera</b> is not working properly`)
        this.noCameraLayer.removeClass('d-none');
        if(error){
            this.cameraErrorHandler(error);
        }
    }

    setCameraOn(){
        // if(!this.videoMuted){
        this.videoMuted=false;
        this.cameraInput.prop('checked',false).trigger('change');
        // }
        this.deviceTroubleshooting.clearError('video');
        this.cameraStatus.html(this.workingState);
        this.peripheralsContainer.addClass('access-given');
        this.cameraStatusSpan.html(`Your <b>camera</b> is working properly`)
        this.noCameraLayer.addClass('d-none');
        this.noCameraMessage.html('');
    }

    setMicrophoneOn(){
        // console.log("Settign microphone on",this.audioMuted)
        if(!this.audioMuted){
            this.microphoneInput.prop('checked',false).trigger('change');
        }
        this.deviceTroubleshooting.clearError('audio');
        this.microphoneStatus.html(this.workingState);
        this.peripheralsContainer.addClass('access-given');
        this.microphoneStatusSpan.html(`Your <b>microphone</b> is working properly`)
    };

    cameraErrorHandler(error) {
        var dm = this;
        dm.deviceTroubleshooting.setError('video', error);
        console.error('error message: ', error.message);
        console.error("Failed to get media device", error.name);
        switch (error.name) {
            case "gum.general":
                    dm.noCameraMessage.html(`We couldn't find your camera, make sure that your camera is connected and not being used by another app.`);
                break;
            case "gum.unsupported_resolution":
            case "NotReadableError":
                dm.noCameraMessage.html(`We couldn't find your camera, make sure that your camera is connected and not being used by another app.`);
                deviceManager.resetCameraDevice((hasCameras=>{
                    if(hasCameras && !this.stopRetryCamera){
                        if(this.audioTrack){
                            this.stopRetryCamera=true;
                            this.cameraDeviceId=deviceManager.lastUsedCamera();
                            this.tryCameraDevice(false);
                        }else{
                            this.stopRetryCamera=true;
                            this.cameraDeviceId=deviceManager.lastUsedCamera();
                            this.testInputDevices();
                        }
                    }
                }));
                break;
            case "NotAllowedError":
            case "gum.permission_denied":
                dm.noCameraMessage.html(`Camera access has been denied. Check for a camera icon in the browser's search bar, allow access, then refresh.`);
                dm.cameraStatusSpan.html(`Allow <b>camera</b> access`)
                break;
            case "NotFoundError":
            case "gum.not_found":
                dm.noCameraMessage.html(`We couldn't find your camera, make sure that your camera is connected and not being used by another app.`);
                break;
            case "OverconstrainedError":

            default:
                dm.noCameraMessage.html(`We couldn't access the camera. Please make sure the camera is connected and is not being used by another application. Try selecting the camera again from the drop down menu when ready.`);;
                return;
                break;
        }
        if(error.message == 'Permission denied by system'){
            if(isMac){
                dm.noCameraMessage.html(`
                    Please check the checkbox next to Kino icon in the Security & Privacy preferences. <br/>
                    Once checked, you can close the Security & Privacy preference window and continue using Kino.
                `);
                return;
            }
            if(isWindows){
                dm.noCameraMessage.html(`
                    Grant access to Kino in Privacy & Security in order to use your camera.<br/>
                    Once the permission is granted, you can close the Privacy & Security window and continue using Kino.
                `);
                return;
            }
        }
    };
    micErrorHandler(error) {
        var dm = this;
        dm.deviceTroubleshooting.setError('audio', error);
        console.error("Failed to get media device", error.name);
        switch (error.name) {
            case "gum.general":
                dm.microphoneStatusSpan.html(`Can't access <b>microphone</b>`);
                break;
            case "NotAllowedError":
            case "gum.permission_denied":
                dm.microphoneStatusSpan.html(`Allow <b>microphone</b> access`)
                break;
            case "NotFoundError":
            case "gum.not_found":
                dm.microphoneStatusSpan.html(`Can't find <b>microphone</b>`);
                break;
            case "OverconstrainedError":

            default:
                dm.microphoneStatusSpan.html(`Your <b>microphone</b> is not working properly`);;
                return;
                break;
        }
        if(error.message == 'Permission denied by system'){
            if(isMac){
                dm.noCameraMessage.html(`
                    Please check the checkbox next to Kino icon in the Security & Privacy preferences. <br/>
                    Once checked, you can close the Security & Privacy preference window and continue using Kino.
                `);
                return;
            }
            if(isWindows){
                dm.noCameraMessage.html(`
                    Grant access to Kino in Privacy & Security in order to use your microphone.<br/>
                    Once the permission is granted, you can close the Privacy & Security window and continue using Kino.
                `);
                return;
            }
        }
    };
    toggleCameraMute(){
        if(this.cameraInput.is(':checked')){
            //unmute
            this.unmuteVideoTrack();
        }else{
            //mute
            this.muteVideoTrack()
        }
    };
    muteVideoTrack(){
        try {
            if(this.effectProccessing){return}
            if(this.videoTrack){
                if(this.vbActive){
                    vb.stopEffect(true,true);
                }
                if(this.privacyModeActive){
                    this.stopPrivacyMode(false);
                }
                this.videoTrack.stream.getTracks().map(t=>{
                    t.stop();
                })
                if(this.videoTrack._originalStream){
                    this.videoTrack._originalStream.getTracks().forEach(t=>t.stop());
                    this.videoTrack._originalStream=undefined;
                }
            }
        } catch (error) {
            console.error(error);
        }
        this.noCameraLayer.removeClass('d-none');
        this.cameraInput.prop('checked',true).trigger('change');
        this.videoMuted=true;
    };

    unmuteVideoTrack(){

        try {
            this.tryCameraDevice(this.cameraDeviceId);
        } catch (error) { console.error("[Kino Error] [KinoLobby]", error); }

    };

    toggleAudioMute(){
        if(this.microphoneInput.is(':checked')){
            //unmute
            this.unmuteAudioTrack();
        }else{
            //mute
            this.muteAudioTrack();
        }
    };
    muteAudioTrack(){
        try {
            this.audioMuted=true;
            if(this.audioTrack){
                this.audioTrack.mute();
            }
            console.log('[MIC-DIAG] KinoLobby.muteAudioTrack', {
                audioMuted: this.audioMuted,
                trackMuted: this.audioTrack?.isMuted?.(),
            });
        } catch (error) {
            console.error(error);
        }
        this.microphoneInput.prop('checked',this.audioMuted).trigger('change');
    };

    unmuteAudioTrack(){
        try {
            this.audioMuted=false;
            if(this.audioTrack){
                this.audioTrack.unmute();
            }else{
                this.tryMicrophoneDevice(this.micDeviceId);
            }
            console.log('[MIC-DIAG] KinoLobby.unmuteAudioTrack', {
                audioMuted: this.audioMuted,
                trackMuted: this.audioTrack?.isMuted?.(),
            });
        } catch (error) {
            console.error(error);
            this.audioMuted=true;
        }
        this.microphoneInput.prop('checked',this.audioMuted).trigger('change');
    };

    openVirtualBackground(){
        try {
            if(this.videoTrack && !this.videoTrack.isMuted()){
                vb.fromLobby=true;
                vb.showPreviewModal(this.videoTrack, true);
            }
        } catch (error) { console.error("[Kino Error] [KinoLobby]", error); }
    };

    togglePrivacyMode(){
        let l = this;
        clearTimeout(l.timeout);
        l.privacyModeButton.addClass('button-disabled')

        if(l.effectProccessing){return}
        if(l.privacyModeActive){
            l.stopPrivacyMode();
        }else{
            l.startPrivacyMode();
        }
        l.timeout = setTimeout(() => {
                l.checkEnableDisablePrivacyBtn();
        }, 2000);
    };

    checkEnableDisablePrivacyBtn(){
        let l = this;
        if(l.videoMuted){
            clearTimeout(l.timeout);
        }else{
            l.privacyModeButton.removeClass('button-disabled')
        }
    }

    async startPrivacyMode(){
        this.effectProccessing=true;
        // if(this.vbActive){
        //     this.vbActive=false;
        //     vb.stopEffect(true);
        //     this.videoTrack.stream=this.videoTrack._originalStream;
        //     if(this.virtualBackgroundIconContainer && this.virtualBackgroundIconContainer.hasClass('enabled')){
        //         this.virtualBackgroundIconContainer.removeClass('enabled')
        //     }
        // }
        this.videoTrack=await privacyMode.startPrivacyMode(this.videoTrack);
        privacyMode.enabled=true;
        privacyMode.updateUIButtons();
        this.localVideoPreview.srcObject=this.videoTrack.stream;
        this.privacyModeActive=true;
        this.privacyModeInput.prop('checked',true).trigger('change');
        this.effectProccessing=false;
    };
    stopPrivacyMode(switchCamera=true){
        this.privacyModeActive=false;
        this.effectProccessing=true;
        this.privacyModeInput.prop('checked',false).trigger('change');
        privacyMode.enabled = false;
        privacyMode.updateUIButtons();
        if (privacyMode.streamEffect) {
            privacyMode.streamEffect.stopEffect();
            privacyMode.streamEffect._inputVideoElement.pause();
            privacyMode.streamEffect._inputVideoElement.srcObject=null;
            privacyMode.streamEffect._inputVideoElement.load();
            privacyMode.streamEffect = undefined;
        }
        if(switchCamera){
            this.tryCameraDevice(this.cameraDeviceId);
        }
        this.effectProccessing=false;
    }
    async onVirtualBackgroundSet(selectedBackground){
        this.effectProccessing=true;
        if (selectedBackground) {
            if(this.privacyModeActive){
                this.stopPrivacyMode(false);
                this.effectProccessing=true;
                this.videoTrack.stream=this.videoTrack._originalStream;
            }
            vb.effect = selectedBackground;
            this.videoTrack=await vb.runEffect(this.videoTrack);
            this.localVideoPreview.srcObject=this.videoTrack.stream;
            this.vbActive=selectedBackground;
            this.effectProccessing=false;
        } else {
            if(this.vbActive){
                this.vbActive=false;
                vb.stopEffect(true);
                this.tryCameraDevice(this.cameraDeviceId);
            }
            this.effectProccessing=false;
        }
    };
    tracksToArray(){
        let tracks=[];
        if(this.audioTrack){
            tracks.push(this.audioTrack);
        }
        if(this.videoTrack){
            tracks.push(this.videoTrack);
        }
        return tracks;
    }
    async joinKino(){
        let l = this;
        l.disableJoinButton();
        if(!await l.kinoAvailability()){
            return
        }
        console.log('[MIC-DIAG] KinoLobby.joinKino', {
            audioMuted: l.audioMuted,
            trackMuted: l.audioTrack?.isMuted?.(),
            hasAudioTrack: !!l.audioTrack,
            hasVideoTrack: !!l.videoTrack,
        });
        animatedLayers.removeScheduledKinoInfo();
        l.joiningTheKinoOverlay();
        if(connection===null){
            initSocketMessage();
            startRoom();
        }
        let localTracks=l.tracksToArray();
        onLocalTracks(localTracks);
        // setTimeout(() => {
        //     l.removeLobbyOverlay();
        // }, 3000);
    };

    setMessage(message,isError=true){
        this.errors.html(message);
        if(isError){
            this.errors.removeClass('info')
        }else{
            this.errors.addClass('info')
        }
    }

    removeConnectingScreen(){
        let screen=$("#kino-connecting-screen");
        screen.animate({opacity:'0'},500,()=>{
            screen.css({display:'none'});
        })
    }

    showConnectingScreen(){
        let screen=$("#kino-connecting-screen");
        // screen.animate({opacity:'0'},500,()=>{
            screen.css({display:'flex',opacity:'1'});
        // })
    }

    showJoiningOverlay(message, showCancel=true, title=''){
        var l = this;
        l.removeJoiningOverlay();

        let showJoinAnimation = $('<div/>',{
            html: [l.reconnectionIcon],
        });

        let showJoinTitle = $('<h3/>',{
            class: 'text-white mb-3',
            html: title
        })

        let showJoinText = $('<div/>',{
            class: 'mb-3 text-center',
            id: 'reconnectionText',
            html: message,
        });

        let showJoinSubText = $('<button/>',{
            class: 'btn mt-2 showJoiningOverlayBtn',
            html: 'Cancel',
        }).on('click', function(){
            if(!socket.connected){
                socket.events.lobbyOnConnection=false;
            }else{
                socket.cancelJoinRequest(ROOM_NAME);
            }
            l.enableJoinButton();
            l.removeJoiningOverlay();
        });

        let showJoinInnerCont = $('<div/>',{
            id: 'reconnectionInnerCont',
            html: [showJoinAnimation,title ? showJoinTitle : '', showJoinText, showCancel ? showJoinSubText : ''],
        });

        l.showJoinOverlay = $('<div/>',{
            class: 'loadingOverlay showJoiningOverlay',
            html: showJoinInnerCont,
        });

        $('body').append(l.showJoinOverlay);
    }

    removeJoiningOverlay(){
        let l = this;
        if(l.showJoinOverlay){
            l.showJoinOverlay.remove();
        }
    }

    joiningTheKinoOverlay(){
        var l = this;
        l.removeJoiningOverlay();

        let showJoinAnimation = $('<div/>',{
            html: `<svg class="circular">
            <circle class="path" cx="14" cy="14" r="10" fill="none" stroke-width="3" stroke-miterlimit="14" />
         </svg>`,
        });

        let showJoinText = $('<h3/>',{
            style: 'font-weight: 600;',
            html: 'Entering the Kino. Stand by...',
        });

        let JoiningTheKinoInnerCont = $('<div/>',{
            id: 'reconnectionInnerCont',
            class: 'd-flex align-items-center justify-content-center flex-row connecting-screen-center-content h-auto',
            html: [showJoinAnimation, showJoinText],
        });

        const kinoLogoContainer = $('<div/>',{
            class: 'connecting-screen-logo d-flex justify-content-center mb-4',
            html: l.kinoLogo
        })

        l.JoiningTheKino = $('<div/>',{
            class: 'align-item-center d-flex flex-column joiningTheKinoOverlay justify-content-center loadingOverlay opacity-0',
            html: [kinoLogoContainer, JoiningTheKinoInnerCont],
        });

        $('body').append(l.JoiningTheKino);
        setTimeout(() => {
            l.JoiningTheKino.removeClass('opacity-0');
        },150)
    }

    removeJoiningTheKinoOverlay(){
        let l = this;
        // console.trace("[SPACES] remove joining the kino overlay",l.JoiningTheKino)
        if(l.JoiningTheKino){
            l.JoiningTheKino.animate({opacity:'0'},500,()=>{
                l.JoiningTheKino.remove();
            })
        }
    }


    setDeviceSettings(settings){
        if(settings.audioDeviceId && settings.audioDeviceId!=this.micDeviceId){
            this.tryMicrophoneDevice(settings.audioDeviceId);
        }
        if(settings.cameraDeviceId && settings.cameraDeviceId != this.cameraDeviceId){
            this.tryCameraDevice(settings.cameraDeviceId);
        }
        if(settings.speakerDeviceId){
            deviceManager.saveSpeaker(settings.speakerDeviceId);
        }else{
            deviceManager.saveSpeaker('communications');
        }
    };

    wasDevicesModalShownBefore(){
        return localStorage.getItem('devices_settings_shown');
    };
    wasDevicesWizardShown(){
        return localStorage.getItem('devices_wizard_shown');
    }

}
